import { render, staticRenderFns } from "./ItemXnor.vue?vue&type=template&id=60b157f4&scoped=true&"
import script from "./ItemXnor.vue?vue&type=script&lang=js&"
export * from "./ItemXnor.vue?vue&type=script&lang=js&"
import style0 from "./ItemXnor.vue?vue&type=style&index=0&id=60b157f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b157f4",
  null
  
)

export default component.exports